/** @jsx h */

import { styleguide } from 'styleguide'
import styled, { css } from 'preact-emotion'
import { h } from 'preact'

const out = css`
  transform: translate3d(0, 40px, 0);
  opacity: 0;
  pointer-events: none;
`

const SkipButton = styled('button')`
  position: absolute;
  right: 0;
  margin: ${styleguide.spacing.m} 0;
  background-color: ${styleguide.colors.background};
  border: 0;
  color: ${styleguide.colors.text};
  border-radius: 100%;
  width: 50px;
  height: 50px;
  padding: ${styleguide.spacing.medium};
  box-shadow: 0px 25px 25px 1px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  font-size: 14px;
  transition: all 300ms ${styleguide.timingFuncs.ease};
  font-family: inherit;
  z-index: 4;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  &:hover {
    transform: translate3d(0, -4px, 0);
    box-shadow: 0px 25px 25px 1px rgba(0, 0, 0, 0.4);
    background-color: ${props => props.brand};
    color: ${styleguide.colors.background};
  }
  ${props => props.out && out};
`

export default function({ style, className, theme, onClick, out }) {
  return (
    <div id="skip-btn">
      <SkipButton
        id="skip"
        style={style}
        out={out}
        onClick={onClick}
        brand={theme.brand}>
        Skip
      </SkipButton>
    </div>
  )
}



// WEBPACK FOOTER //
// ../api/src/Skip.jsx